module.exports = __webpack_public_path__ + "static/media/tel.bfb8a89b.png";